import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/surgery-procedure-type";

export const pagingSurgeryProcedureType = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getSurgeryProcedureTypeById = (surgeryProcedureTypeId) => axios.get(API_PATH + "/get-by-id/" + surgeryProcedureTypeId);

export const saveOrUpdateSurgeryProcedureType = surgeryProcedureType => axios.post(API_PATH + "/save-or-update", surgeryProcedureType);

export const deletesurgeryProcedureType = surgeryProcedureTypeId => axios.delete(API_PATH + '/mark-delete/' + surgeryProcedureTypeId);

